import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const DashboardProcurement = () => {
  document.title = 'Dashboard | Pertamina DigiProcHydro';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Dashboard' pageTitle='Dashboards' />

          {/* Welcome Content */}
          <Row className='justify-content-center'>
            <Col xl={8} lg={10}>
              <Card className='text-center'>
                <CardBody className='py-5'>
                  <div className='mb-4'>
                    <i
                      className='bx bx-buildings display-1 text-primary'
                      style={{ fontSize: '120px' }}
                    ></i>
                  </div>
                  <h2 className='mb-3 text-dark'>
                    Welcome to Digital Procurement Hydro Apps
                  </h2>
                  <p className='text-muted fs-16 mb-4'>
                    Dashboard is not developed yet!
                  </p>
                  <div className='alert alert-warning' role='alert'>
                    <i className='bx bx-info-circle me-2'></i>
                    <strong>Under Development:</strong> The dashboard features
                    are currently being developed
                  </div>

                  {/* Additional info */}
                  <div className='mt-4 pt-3 border-top'>
                    <p className='text-muted mb-2'>
                      <i className='bx bx-calendar me-1'></i>
                      {'  '}
                      Last updated:{' '}
                      {new Date().toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </p>
                    <p className='text-muted mb-0'>
                      <i className='bx bx-support me-1'></i>
                      For support, please contact the development team
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardProcurement;
